export default "/images/diners-club.png";